import { Middleware, PayloadAction, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'
import { GenerationEvent } from '@repo/shared/events/generation'

import { RootState } from '@/store'
import { ThunkExtra } from '@/store/actions'
import { AssistantFeedItem } from '@/store/assistant'

export interface ISocket {
  emit: <T extends { generationId: string }>(key: string, payload: T) => void
  listen: <T extends GenerationEvent<AssistantFeedItem>>(key: string, cb: (v: T) => void) => void
}

export type Action = PayloadAction<unknown> & {
  meta: { arg: Record<string, unknown> }
}

export enum FakeGenerationEnum {
  AskForCompleteOnboarding = 'askForCompleteOnboarding',
  AskForDescription = 'askForDescription',
  AskForMembers = 'askForMembers',
  AskForMethodology = 'askForMethodology',
  AskForResources = 'askForResources',
  AskForUpdatingDescription = 'askForUpdatingDescription',
  AskForUpdatingMethodology = 'askForUpdatingMethodology',
}

export type MiddlewareType = Middleware<
  object,
  RootState,
  ThunkDispatch<RootState, ThunkExtra, UnknownAction>
>
